import { render, staticRenderFns } from "./InventoryWindowStickerCapture.vue?vue&type=template&id=60aafc47&scoped=true"
import script from "./InventoryWindowStickerCapture.vue?vue&type=script&lang=js"
export * from "./InventoryWindowStickerCapture.vue?vue&type=script&lang=js"
import "./InventoryWindowStickerCapture.vue?vue&type=style&index=0&id=60aafc47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aafc47",
  null
  
)

export default component.exports